import { useEffect } from "react";
import { motion } from "framer-motion";
import { Linkedin, MapPin, MessageCircle } from "lucide-react";
import { EASE, IMG, LeadForm, Line, Reveal } from "@/components/shared";
import { useLang } from "@/i18n";

export default function Company() {
  const { t } = useLang();
  useEffect(() => { document.title = "Company & Contact | AsaanCharge"; }, []);
  const milestones = [
    { number: "01", title: t("ms1T"), copy: t("ms1P"), state: "done" },
    { number: "02", title: t("ms2T"), copy: t("ms2P"), state: "now" },
    { number: "03", title: t("ms3T"), copy: t("ms3P"), state: "next" },
    { number: "04", title: t("ms4T"), copy: t("ms4P"), state: "next" },
  ];
  return (
    <>
      <section className="page-hero container">
        <motion.div className="eyebrow" initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1, ease: EASE }}><span className="pulse-dot" /> {t("compEyebrow")}</motion.div>
        <h1><Line delay={0.22}>{t("compL1")}</Line><Line delay={0.34}><em>{t("compL2")}</em></Line></h1>
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.6, ease: EASE }}>{t("compSub")}</motion.p>
      </section>

      <section className="founder-section" id="founders" data-testid="founder-story-section">
        <div className="container founder-wrap">
          <div className="founder-copy">
            <Reveal><div className="eyebrow">{t("fndEyebrow")}</div><h2>{t("fndL1")}<em>{t("fndL2")}</em></h2><p className="founder-lead">{t("fndLead")}</p></Reveal>
            <div className="founder-grid">
              <Reveal delay={0.1} data-testid="founder-zubair-card"><img className="founder-photo" src="/founder-zubair.jpeg" alt="Zubair Rashied, co-founder of AsaanCharge" data-testid="founder-zubair-photo" /><span className="card-kicker">01 / ZUBAIR RASHIED</span><h3>{t("fnd1H")}</h3><p>{t("fnd1P")}</p><a className="founder-link" href="https://www.linkedin.com/in/zubair-rashied-7b4b1781/" target="_blank" rel="noreferrer" data-testid="founder-zubair-linkedin"><Linkedin /> LinkedIn</a></Reveal>
              <Reveal delay={0.2} data-testid="founder-waseem-card"><img className="founder-photo" src="/founder-waseem.png" alt="Muhammed Waseem, co-founder of AsaanCharge" data-testid="founder-waseem-photo" /><span className="card-kicker">02 / MUHAMMED WASEEM</span><h3>{t("fnd2H")}</h3><p>{t("fnd2P")}</p><a className="founder-link" href="https://www.linkedin.com/in/muhammad-waseem-247a20a3/" target="_blank" rel="noreferrer" data-testid="founder-waseem-linkedin"><Linkedin /> LinkedIn</a></Reveal>
            </div>
          </div>
          <Reveal className="founder-art" delay={0.15}>
            <figure><img src={IMG.founders} alt="Portable power moving to where it is needed" data-testid="founder-share-image" /><figcaption>{t("fndCaption")}</figcaption></figure>
          </Reveal>
        </div>
      </section>

      <section className="section where-section container">
        <Reveal className="section-heading"><div><div className="eyebrow">{t("whereEyebrow")}</div><h2>{t("whereL1")}<br /><em>{t("whereL2")}</em></h2></div><p>{t("whereP")}</p></Reveal>
        <div className="timeline">{milestones.map((m, index) => <Reveal className={`milestone ${m.state}`} key={m.number} delay={index * 0.08} data-testid={`milestone-${m.number}`}><span>{m.number}</span><div><h3>{m.title}{m.state === "now" && <em className="milestone-now">{t("msNow")}</em>}</h3><p>{m.copy}</p></div></Reveal>)}</div>
      </section>

      <section className="contact-section" id="contact">
        <div className="container contact-wrap">
          <Reveal className="contact-copy"><div className="eyebrow">{t("conEyebrow")}</div><h2>{t("conL1")}<br /><em>{t("conL2")}</em></h2><p>{t("conP")}</p><div className="contact-details"><span><MapPin size={18} /> {t("conLoc")}</span><a href="https://wa.me/923318882566" target="_blank" rel="noreferrer" data-testid="contact-whatsapp-link"><MessageCircle size={18} /> {t("conWhats")}</a></div></Reveal>
          <Reveal className="lead-form-wrap" delay={0.12}><LeadForm /></Reveal>
        </div>
      </section>
    </>
  );
}
